import { useState } from "react";

const AccordionItem = ({ title, content, isOpen, onClick }) => (
  <div
    style={{
      border: "1px solid #e1d0c2",
      borderRadius: "10px",
      marginBottom: "1rem",
      overflow: "hidden"
    }}
  >
    <div
      onClick={onClick}
      style={{
        padding: "10px 15px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        cursor: "pointer",
        background: "#faf7f5"
      }}
    >
      <h3 style={{ margin: 0 }}>{title}</h3>
      <img
        src={isOpen ? "/images/arrow-up.svg" : "/images/arrow-down.svg"}
        alt="toggle icon"
        style={{ width: "20px", height: "20px" }}
      />
    </div>
    {isOpen && (
      <div style={{ padding: "10px 15px", background: "#fff" }}>
        <p style={{ margin: 0 }}>{content}</p>
      </div>
    )}
  </div>
);

const AccordionList = () => {
  const [openItems, setOpenItems] = useState([0]); // eerste item open

  const toggleItem = (index) => {
    setOpenItems(
      (prev) =>
        prev.includes(index)
          ? prev.filter((i) => i !== index) // sluit item
          : [...prev, index] // open item
    );
  };

  const data = [
    {
      title: "Telefonisch bereikbaar",
      content:
        "Queen Center wil haar klanten graag in alle rust kunnen behandelen. Tijdens de behandelingen wordt de telefoon dan ook niet aangenomen. Spreek daarom de voicemail in, dan bellen wij u zo spoedig mogelijk terug. Wij proberen dit altijd dezelfde dag nog te doen. Uiteraard kunt u ons ook een e-mail sturen: info@queencenter.nl. Vaak lukt het ons hier een sneller antwoord op te geven, omdat wij tussen de behandelingen door de e-mails lezen."
    },
    {
      title: "Betaalmogelijkheden",
      content: "Bij Queen Center betaalt u met pin of contant."
    },
    {
      title: "Annuleren of verzetten",
      content:
        "Het kan een keer voorkomen dat u uw gemaakte afspraak niet redt. Wij willen u vragen om dit 72 uur voor aanvang van de behandeling telefonisch aan ons door te geven. Dit geeft ons de ruimte om nog iemand anders op de geannuleerde tijd in te plannen. De reserveringskosten van € 25,- worden ingehouden wanneer u een afspraak niet of niet tijdig annuleert."
    },
    {
      title: "Mobiele telefoons",
      content:
        "Graag willen wij u vragen om uw mobiele telefoon tijdens de behandeling uit te zetten. Zo kunt u ongestoord genieten van de behandeling en zich meer ontspannen. Het is daarbij ook niet mogelijk om de behandeling te onderbreken voor telefoongesprekken (uitzonderingen natuurlijk daargelaten)."
    },
    {
      title: "Kinderen",
      content:
        "Bij Queen Center zijn we dol op kinderen, maar wij hebben helaas geen kinderopvangmogelijkheden of kindervoorzieningen. Om de rust te bewaren in de kliniek zouden we mama graag vragen om voor dit moment even alleen te komen genieten."
    },
    {
      title: "Parkeermogelijkheden",
      content: "U kunt uw auto gratis parkeren."
    },
    {
      title: "Uw gegevens",
      content:
        "Wij gaan zorgvuldig en vertrouwelijk om met uw gegevens, wat ons betreft is dat vanzelfsprekend. Wij handelen volgens de huidige privacy- en regelwetgeving. U bent zelf verantwoordelijk voor het doorgeven van uw gegevens aan onze praktijk, dus ook als deze wijzigen. Heeft u bijvoorbeeld een nieuw adres of telefoonnummer? Geef uw wijziging bij voorkeur door aan ons per e-mail of aan de balie."
    },
    {
      title: "Hygiëne",
      content:
        "Wij hechten veel waarde aan een goede hygiëne. Het is daarom in de gehele praktijk niet toegestaan om te roken of huisdieren mee te nemen."
    },
    {
      title: "Heeft u een klacht?",
      content:
        "Wij proberen u te allen tijde zo goed mogelijk van dienst te zijn. Mocht u toch een klacht hebben over een behandeling en/of product dan willen wij u vragen dit zo spoedig mogelijk bij ons kenbaar te maken. Wij zullen dan proberen om samen met u tot een oplossing te komen."
    },
    {
      title: "Huidscan",
      content:
        "Een gratis huidscan (incl. 2 producten) kunt u alleen telefonisch of per e-mail boeken."
    }
  ];

  return (
    <section className="afspraak-info">
      <h2>Aandachtspunten</h2>
      {data.map((item, index) => (
        <AccordionItem
          key={index}
          title={item.title}
          content={item.content}
          isOpen={openItems.includes(index)}
          onClick={() => toggleItem(index)}
        />
      ))}
    </section>
  );
};

export default AccordionList;
